import { Component, inject, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { allowOnlyLetters, allowLimitedInput, trimInput, handlePasteText } from '../../master.utils';
import { ToastrService } from 'ngx-toastr';
import { CargoService } from 'src/app/shared/service/disbursment/cargo.service';

@Component({
  selector: 'app-create-cargo',
  templateUrl: './create-cargo.component.html',
  styleUrls: ['./create-cargo.component.scss']
})
export class CreateCargoComponent {
 private loader = inject(DisbursmentService);
 isLoading$ = this.loader.loading$;

  disallowNumericData = allowOnlyLetters;
  allowLimitedInput = allowLimitedInput;
  cargoForm: FormGroup;
  isEditMode = false;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateCargoComponent>,
    @Inject(MAT_DIALOG_DATA) public existingdata: any,
    private cargoService: CargoService,
    private snackBar: ToastrService
  ) {
    const data = existingdata?.rowData;
    this.isEditMode = !!data;
    this.cargoForm = this.fb.group({
      cargo_id: [data?.cargo_id || 0],
      type: [data?.type || '', Validators.required],
    });
  }
  //method to trim the input
  onInputTrim(controlName: string): void {
    const control = this.cargoForm.get(controlName);
    trimInput(control);
  }


  onPaste(event: ClipboardEvent): void {
    const value = handlePasteText(event);
    this.cargoForm.get('type')?.setValue(value);
  }

  // onSubmit method will trigger when the Add or Edit cargo button clicks
  onSubmit() {
    if (this.cargoForm.valid) {
      this.loader.showDialogLoader();
      this.cargoService.CargoDataToDB(this.cargoForm.value).subscribe({
        next: (res) => {
          this.loader.hideDialogLoader();
          this.snackBar.success(res.message);
          this.dialogRef.close("refresh");
        },
        error: (error) => {
          this.loader.hideDialogLoader();
          const errorMsg = error.error?.error || 'Something went wrong. Please try again.';
          this.snackBar.error(errorMsg);
        }
      })
    }
  }


  closeDialog() {
    this.dialogRef.close();
  }
}
